import { render, staticRenderFns } from "./appHouseholdPortrait.vue?vue&type=template&id=61c45005&"
import script from "./appHouseholdPortrait.vue?vue&type=script&lang=js&"
export * from "./appHouseholdPortrait.vue?vue&type=script&lang=js&"
import style0 from "./appHouseholdPortrait.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports